import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Div = styled.div`
  position: absolute;
  display: inline-block;
  font-size: 15px;
  font-weight: 300;
  color: #ccc;
  border-radius: 0;
  border: none;
  width: 1.5rem;
  padding-top: 0.2rem;
  text-align: center;
`;

const InputPrefix = ({ inputPrefix }) => {
  if (!inputPrefix) {
    return null;
  }
  return <Div>{inputPrefix}</Div>;
};
InputPrefix.propTypes = {
  inputPrefix: PropTypes.string,
};
InputPrefix.defaultProps = {
  inputPrefix: '',
};
export default InputPrefix;
